import API from "@common/API"

const AuditService = {
  getAuditChangesForUsers(): Promise<unknown> {
    return API.get(`/audit/users?diff=true`)
  },
}

export default AuditService
